import React from 'react';
import Select from './components/select/select';
import Typeahead from './components/typeahead/typeahead';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

function padZero(val) {
    return ('0' + val).slice(-2);
}

function getInputs(fields) {
    return fields.map(field => <div key={field.name}
        className={'form-group px-3 col' + (field.width ? `-${field.width}` : '')}>
        <label className='small m-0 text-nowrap'
            htmlFor={field.name}>{field.label}</label>
        {getInput(field)}
    </div>);
}

function getInput({
    label = '',
    name = '',
    value = '',
    hold = '',
    type = 'text',
    required = false,
    readOnly = false,
    rows = 2,
    options = [],
    multiple = false,
    selectAll = false,
    onChange = _ => false,
    onKeyPress = _ => false,
    removeValue = _ => false,
}) {
    let el = null;
    switch (type) {
        case 'textarea':
            el = <textarea className={`form-control form-control-sm rounded-0 bg-transparent text-light ${required && !value.trim().length ? 'is-invalid' : ''}`}
                id={name}
                name={name}
                rows={rows}
                placeholder={label}
                value={value}
                onChange={onChange}
                required={required}
                readOnly={readOnly}></textarea>
            break;
        case 'select':
            el = <Select label={label}
                name={name}
                value={value}
                required={required}
                readOnly={readOnly}
                options={options}
                multiple={multiple}
                selectAll={selectAll}
                onChange={onChange} />
            break;
        case 'typeahead':
            el = <Typeahead options={options}
                onChange={onChange}
                name={name} 
                value={value} />
            break;
        default:
            if (multiple) {
                el = <>
                    <div className='d-flex flex-wrap'>
                        {
                            value.map((val, i) => <div key={val}
                                className='text-nowrap border rounded px-1 mr-1 mb-1'>
                                {val}
                                <i className='ml-1 cursor-pointer'
                                    onClick={_ => removeValue(i)}><FontAwesomeIcon icon={faTimesCircle} /></i>
                            </div>)
                        }
                    </div>
                    <input type={type}
                        className='form-control form-control-sm rounded-0 bg-transparent text-light p-0'
                        id={name}
                        name={name}
                        placeholder={label}
                        value={hold}
                        onKeyPress={onKeyPress}
                        onChange={onChange}
                        required={required}
                        readOnly={readOnly}
                        autoComplete='off' />
                </>
            }
            else {
                el = <input type={type}
                    className={`form-control form-control-sm rounded-0 bg-transparent text-light p-0 ${required && !value ? 'is-invalid' : ''}`}
                    id={name}
                    name={name}
                    placeholder={label}
                    value={value}
                    onChange={onChange}
                    required={required}
                    readOnly={readOnly}
                    autoComplete='off' />
            }
            break;
    }
    return el;
}

function getDisplayTime(timeStamp) {
    if (timeStamp) {
        let date = new Date(timeStamp);
        return `${padZero(date.getUTCHours())}:${padZero(date.getUTCMinutes())} (Z)\n${padZero(date.getHours())}:${padZero(date.getMinutes())} (L)`;
    }
}

function getUTCDateTime(timeStamp, format) {
    const d = new Date(timeStamp);
    const retval = format.replace(/Y/g, d.getUTCFullYear())
        .replace(/M/g, padZero(d.getUTCMonth() + 1))
        .replace(/D/g, padZero(d.getUTCDate()))
        .replace(/h/g, padZero(d.getUTCHours()))
        .replace(/m/g, padZero(d.getUTCMinutes()))
        .replace(/s/g, padZero(d.getUTCSeconds()));
    return retval;
}

export {
    padZero,
    getInputs,
    getInput,
    getDisplayTime,
    getUTCDateTime,
}